export function fmtDate(d) {
  if (!d) return "-";
  try { const dt = new Date(d); if (isNaN(dt)) return d; return dt.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return d; }
}
export function fmtDateTime(d) {
  if (!d) return "-";
  try { const dt = new Date(d); if (isNaN(dt)) return d; return dt.toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return d; }
}
export const isOverdue = (d) => {
  if (!d) return false;
  try { const t = new Date(d); const today = new Date(); today.setHours(0, 0, 0, 0); return t < today; }
  catch { return false; }
};
export function fmtRupiah(n) {
  const v = Number(n || 0);
  return "Rp " + v.toLocaleString("id-ID", { maximumFractionDigits: 0 });
}
export const fmtOrEmpty = (n, empty = "BELUM TERISI") => (n == null ? empty : fmtRupiah(n));
